<template>
  <div>
    <FileUploadModel
      :uploadFileListTitle="$t('param.param-import')"
      :uploadFileListName="$t('param.param-import-list')"
      :uploadURL="'/rest/terminalParam/import'"
      :extensionName="['xls', 'xlsx']"
      :acceptFileTypes="'.xls,.xlsx'"
      :templateURL="'/tempFiles/ParamTemplate.xlsx'"
      :templateName="'ParamTemplate.xlsx'"
      :isShowBack="true"
    />
  </div>
</template>

<script setup></script>
